import WebbDividerMedium from '../content/webx/webb-divider-md'

export const Divider = ({ value = 1 }) =>
  Array(value).fill(() => <WebbDividerMedium />)
